import styles from './CheckBox.module.scss';

export const CheckBox = ({ id, checked, onChange }) => (
  <>
    <input type='checkbox' id={id} className={styles.checkbox} checked={checked} onChange={onChange} />
    <label htmlFor={id} className={styles.checkboxLabel} />
  </>
);
